import {FormTypeEnum} from './formType';
import {IconEnum} from './icon';
import {LevelEnum} from './level';
import {PermissionsEnum} from './permissions';
import {StatusEnum} from './status';
import {ServiceEnum} from '@/enums/service';

export namespace Enum {
  export const IconType = IconEnum.IconType;

  export const FormType = FormTypeEnum.FormType;

  export const PageGroup = FormTypeEnum.PageGroup;

  export const PageType = FormTypeEnum.PageType;

  export const UseCase = PermissionsEnum.UseCase;

  export const OperateType = PermissionsEnum.OperateType;

  export const BOLevel = LevelEnum.BOLevel;
  export const BgLevel = LevelEnum.BgLevel;

  export const ECLevel = LevelEnum.ECLevel;
  export const CustTypeLevel = LevelEnum.CustTypeLevel;
  export const BudGetControlType = StatusEnum.BudgetControlType;
  export const ReimburseType = StatusEnum.ReimburseType;

  export const SoSkuCategoryLevel = LevelEnum.SoSkuCategoryLevel;

  export const DistrictLevel = LevelEnum.DistrictLevel;

  export const ProductLevel = LevelEnum.ProductLevel;

  export const FormStatus = StatusEnum.FormStatus;

  export const ExportStatus = StatusEnum.ExportStatus;

  export const InvoiceStatus = StatusEnum.InvoiceStatus;

  export const SyncStatus = StatusEnum.SyncStatus;

  export const RebateInfoStatus = StatusEnum.RebateInfoStatus;
  export const DistrictLevels = LevelEnum.DistrictLevel;

  export const Service = ServiceEnum.Service;

  export enum DiscountType {
    //降价
    DISCOUNT = 1,
    //搭赠
    BUY_GIVE = 2,
    //事后补齐
    COMMON = 3,
  }

  export enum BOHQ {
    DC = 1,
    DI = 2,
    HK = 3,
  }

  export enum BohqLevel {
    BOHQ_CATEGORY = 1,
    BOHQ = 2,
  }

  export enum Bu {
    HQ = 10,
    YN = 11,
    NF = 14,
    QZ = 15,
    XN = 12,
    TQ = 13,
    ZY = 16,
  }

  export enum HomeSequence {
    ANNOUNCEMENT = '1',
    WAIT_FOR_MY_APPROVAL = '2',
    MY_APPROVED = '3',
    MY_DRAFT = '4',
    MY_SUBMIT = '5',
    MY_FAVORITE = '6',
    MAIL_TO_MY_APPROVED = '7',
    MY_COMMUNICATED = '8',
    MY_SYSTEM_MSG = '9'
  }

  export enum ExtendsBT {
    //1:超申请结案
    SETTLE_OVER_APPLY = 1,
    //2:超预提结案
    SETTLE_OVER_ACCRUAL = 2,
  }

  /**
   * 支付方式 <br />
   * 1,转账 <br />
   * 2,账扣 <br />
   * 3,票扣(调整单) <br />
   * 4,货补(KA) <br />
   * 5,第三方付款 <br />
   * 7,费用池(经销商) <br />
   * 8,货补池(经销商) <br />
   * 10,记账 <br />
   */
  export enum PaymentMethod {
    /**
     * 转账
     */
    TRANSFER = 1,
    /**
     * 账扣
     */
    ACCOUNT_DEDUCT = 2,
    /**
     * 票扣(调整单)
     */
    BILL_DEDUCT = 3,
    /**
     * 货补(KA)
     */
    FREE_GOODS = 4,
    /**
     * 第三方付款(给供应商/员工)
     */
    THIRD_PART = 5,
    /**
     * 费用池(经销商)
     */
    FEE_POOL = 7,
    /**
     * 货补池(经销商)
     */
    FG_POOL = 8,
    /**
     * 搭赠池(经销商)
     */
    BUY_GIVE_POOL = 9,
    /**
     * 记账(不预提)
     */
    ACCOUNTING_NO_ACCRUAL = 10,
    /**
     * 记账(预提)
     */
    ACCOUNTING_ACCRUAL = 11,
  }


  export enum PayToType {
    PAY_TO_SOLD_TO=1,
    PAY_TO_SUPPLIER=2,
    PAY_TO_STAFF=3,
  }

  export enum BohqType {
    //非广告
    GENERAL = 1,
    //广告
    MKT = 2,
  }

  export enum BohqRebateType {
    //按选择的预算归属
    CURRENT_BOHQ = 1,
    //按使用部门的默认预算归属
    DEFAULT_BOHQ = 2,
  }

  export enum FormRelationType {
    //退回单据的修改
    REJECTED = 1,
    //变更申请
    MODIFIED = 2,
    //单据复制
    COPY = 3,
  }

  export enum AccrualMethodType {
    // 后补固定类
    FIXED = 1,
    // 后补随量类
    REVENUE_SELLIN = 2,
    // // 随货降价类（不预提）
    // PriceDiscount = 21,
    // // 随货搭赠类（不预提）
    // Giveaway = 22,
    // // 免费货申请类（不预提）
    // FreeGoods = 31,
    // // 系统外费用（不预提）
    // NonTPM = 32
  }

  export enum ProcessMode {
    //自动生成
    AUTO_ACCRUAL_AND_SETTLE = 1,
    //手动申请
    NON_AUTO = 2,
    //手动结案
    NON_AUTO_SETTLE = 3,
    //外部导入
    NON_TPM_IMPORT = 4,
    //定额自动生成
    AUTO_ACCRUAL_AND_SETTLE_FIXED_AMOUNT = 5,
  }

  export enum FlowControlType {
    NONE = 0,
    NOT_RETURN = 1,
    NOT_DISAGREE = 2,
  }

  export enum RevenueType {
    /**
     * 固定类-通用活动
     */
    FIXED = 1,
    /**
     * 出货量-不含赠(主单位)-通用活动
     */
    SELLIN_QTY = 101,
    /**
     * 出货额-返利折扣后(含税)-合同
     */
    SELLIN_REV_151_IN_VAT = 151,
    /**
     * 出货额-返利折扣后(未税)-合同
     */
    SELLIN_REV_152_EX_VAT = 152,
    /**
     * 出货额-返利折扣前(含税)-通用活动,合同
     */
    SELLIN_REV_171_IN_VAT = 171,
    /**
     * 出货额-返利折扣前(未税)-通用活动,合同
     */
    SELLIN_REV_172_EX_VAT = 172,
    /**
     * 出货额-返利折扣前排除退货(含税)-合同
     */
    SELLIN_REV_173_IN_VAT = 173,
    /**
     * 出货额-返利折扣前排除退货(未税)-合同
     */
    SELLIN_REV_174_EX_VAT = 174,
    /**
     * 开票额-返利折扣后(含税)-合同
     */
    BILLING_REV_251_IN_VAT = 251,
    /**
     * 开票额-返利折扣后(未税)-合同
     */
    BILLING_REV_252_EX_VAT = 252,

    /**
     * POS量-补供价-通用活动
     */
    POS_QTY_SUPPLY_PRICE = 301,
    /**
     * POS量-补供价(固定预提)-通用活动
     */
    POS_QTY_SUPPLY_PRICE_FIXED = 302,
    /**
     * POS量-补售价-通用活动
     */
    POS_QTY_SELLIN_PRICE = 303,
    /**
     * POS量-补售价(固定预提)-通用活动
     */
    POS_QTY_SELLIN_PRICE_FIXED = 304,
    /**
     * POS额-通用活动
     */
    POS_REV = 311,
    /**
     * POS额(固定预提)-通用活动
     */
    POS_REV_FIXED = 312,
    /**
     * 随货特价KA-随货活动
     */
    DISCOUNT_KA = 401,
    /**
     * 随货特价GT-随货活动
     */
    DISCOUNT_GT = 402,
    /**
     * 随货特价GT-随货活动
     */
    BUY_GIVE = 411,
    /**
     * 免费货
     */
    FG = 501,
  }

  export  enum FileType{
    NONE='none',
    IMG='img',
    WORD='word',
    EXCEL='excel',
    PPT='ppt',
    PDF='pdf',
    TXT='txt',
  }

  export enum FieldType {
    BOOLEAN = 'Boolean',
    NUMBER = 'Number',
    DATE_TIME = 'DateTime',
    TEXT = 'Text',
  }

  export enum FieldDataType {
    BOOLEAN = 'Boolean',
    INT = 'Int',
    DECIMAL = 'Decimal',
    DATE_TIME = 'DateTime',
    STRING = 'String',
  }

  export enum AttachmentGenerateType {
    /**
     * TPM 服务器配置默认文件目录
     * 根据配置决定存储在文件服务器，或者OBS服务器
     */
    DEFAULT = 1,

    /**
     * TPM 系统产生的附件，日志文件，存在硬盘
     */
    SYSTEM = 2,

    /**
     * 系统自定义的文件目录配置如登录页配置的图片，产品图片等
     */
    CUSTOM = 3,

    /**
     * 系统自定义的文件目录配置如登录页配置的图片，产品图片等
     */
    TEMP = 4,
  }

  export enum AttachmentCustomPrefix {
    OBS_CUSTOM_PREFIX = 'obs_custom://',
    FILE_CUSTOM_PREFIX = 'file_custom://',
  }

  export enum PolicyType {
    // 随货特价类(无需申请)
    PD_DISCOUNT = 1,
    // 随货特价类(需申请)
    PD_DISCOUNT_FOR_ACTIVITY = 2,
    // 随货搭赠类(无需申请)
    PD_BUY_GIVE = 3,
    // 随货搭赠类(需申请)
    PD_BUY_GIVE_FOR_ACTIVITY = 4,
    //  后补自动计算类(无需申请)
    AUTO_CALC = 5,
    //  后补自动计算类(需申请)
    AUTO_CALC_FOR_ACTIVITY = 6,
    // 后补自动计算类(发货预提)
    AUTO_CALC_BY_DELIVERY = 7,
    //  后补自动计算类(君币核销类)
    AUTO_CALC_BY_JUNBI = 8,
    // 后补手工计算类(无需申请)
    MANUAL_CALC = 9,
    //  后补手工计算类(需申请)
    MANUAL_CALC_FOR_ACTIVITY = 10,
  }

  export enum SalesContractType {
    // 一级客户合同
    SELLIN = 1,
    // 二级客户合同
    SELLOUT = 2,
  }

  export enum SalesContractStatus {
    // 修改中
    MODIFY = 1,
    // 有效
    EFFECTIVE = 2,
    //无效
    INVALID = 3,
  }

  export enum SettlementMode {
    //必须结案
    REQ_SETTLE = 1,
    //可不结案
    NON_REQ_SETTLE = 2,
    //无需结案
    NO_SETTLE = 3,
  }

  export enum PersistenceType {
    FINANCIAL = 1,
    SYSTEM_PARAMETER = 2,
  }

  export enum SoldToLevel {
    MAIN = 1,
    SUB = 2,
  }

  export enum SoldToType {
    //经销商
    DEALER = 1,
    //直营
    KA = 2,
    //电商
    DS = 3,
    //司机
    DRIVER = 4,
    //直采
    DIRECT = 5,
  }

  export enum PolicyTargetType {
    FIXED_AMOUNT = 1,
    FIXED_QUANTITY = 2,
    YEAR_ON_YEAR = 3,
    MONTH_ON_MONTH = 4,
    ACTIVITY_TARGET_QUANTITY = 5,
    ACTIVITY_TARGET_REVENUE = 6,
  }

  export enum TermsPolicyType {
    //达量产品
    REACH_PRODUCT = 1,
    //返利产品
    REBATE_PRODUCT = 2,
    //购买产品
    BUY_PRODUCT = 3,
    //赠送产品
    GIVEAWAY_PRODUCT = 4,
    //特价产品
    DISCOUNT_PRODUCT = 5,
  }

  export enum TermsProductTypeEnum {
    //达量
    REACH = 1,
    //返利 (购买产品, 特价产品)
    REBATE = 2,
    //赠送产品
    REACH_EX = 3,
    REBATE_EX = 4,
  }

  export enum ProductType {
    /**
     * 成品
     */
    FINISHED = 1,

    /**
     * 非成品
     */
    NON_FINISHED = 2,
  }

  export enum SalesType {
    SELLIN = 1,
    SELLOUT = 2,
    POS = 3,
  }

  export enum InvoiceSource {
    // 手工录入
    CREATE = 1,
    // 百旺
    BAI_WANG = 2,
  }

  export enum InvoiceType {
    // 专用发票
    SPECIAL = 1,
    // 普通发票
    GENERAL = 2,
  }

  export enum BohqCategory {
    C2B = 1,
    B2B = 2,
    //企划类
    PLANNING = 101,
  }

  export enum UomType {
    //销售单位
    EA = 1,
    //最小单位
    MIN = 2,
  }

  export enum RebateType {
    /**
     * 一级客户合同
     */
    CONTRACT_LEVEL1 = 1,

    /**
     * 二级客户合同
     */
    CONTRACT_LEVEL2 = 2,

    /**
     * 产品政策返利生成
     */
    PRODUCT_POLICY = 3,
  }

  export enum DeptLevel {
    ROOT = 0,
    DEPT_LEVEL1 = 1,
    DEPT_LEVEL2 = 2,
    DEPT_LEVEL3 = 3,
    DEPT_LEVEL4 = 4,
  }

  export enum AdoptScope {
    /**
     * 按客户
     */
    Custom = 1,
    /**
     * 按客户分类
     */
    CustomType = 2,
    /**
     * 跨区客户
     */
    CrossReginCustom = 3,
  }

  /**
   * 核算类型适用类型
   */

  export enum RevApplyType {
    /**
     * 通用活动
     */
    SA_GENERAL = 2,
    /**
     * 合同
     */
    CONTRACT = 4,
    /**
     * 随货
     */
    SA_PD = 8,
  }

  export enum BoType {
    BO_TYPE1 = 1,
    BO_TYPE2 = 2,
  }

  export enum ProcessNodeType {
    //正常审批节点
    FORMAL = 10,
    //知会节点
    SEND_MAIL = 12,
    //自动审批节点
    AUTO_APPROVER = 99,
    //加签节点
    TEMP = 100,
  }

  export enum WorkFlowRoleType {
    ROLE_POSITION = 1,
    ROLE_USER = 2,
  }

  export enum BohqLevle {
    ROOT = 0,
    BOHQ_LEVEL1 = 1,
    BOHQ_LEVEL2 = 2,
  }

  export enum PayType {
    CASH = 1,
    OTHERS = 11,
  }

//支付给
  export enum PayToType {
    SOLD_TO = 1,
    SUPPLIED = 2,
    STAFF = 3,
  }
}
